/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type { GetCreditBalanceQueryResponse } from '../types/GetCreditBalance'

function getGetCreditBalanceUrl() {
  const res = {
    method: 'GET',
    url: `/api/v1/contact_request/credits/` as const,
  }
  return res
}

/**
 * @description Get credit balance from our database
 * @summary Get the company's contact-credit balance
 * {@link /api/v1/contact_request/credits/}
 */
export async function getCreditBalance(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetCreditBalanceQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getGetCreditBalanceUrl().url.toString(),
    ...requestConfig,
  })
  return res.data
}
